/**
 * Recursively searches for a key within a nested object and returns its corresponding value.
 * @param {Object} obj - The object to search within.
 * @param {string} key - The key to search for.
 * @returns {*} The value corresponding to the specified key if found, otherwise undefined.
 */
export default function recursiveFindKeyValue(obj, key) {
    if (!obj || typeof obj !== 'object') return undefined;

    for (const prop in obj) {
        if (prop === key) {
            return obj[prop];
        }

        const value = obj[prop];
        if (value && typeof value === 'object') {
            const result = recursiveFindKeyValue(value, key);
            if (result !== undefined) {
                return result;
            }
        }
    }

    return undefined; // Key not found
}
